/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import parse from "html-react-parser"

function Seo({
  description = ``,
  lang = `es`,
  meta = [],
  title,
  image,
  yoastHead
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            keywords
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      //titleTemplate={`%s | ${site.siteMetadata.title}`}
      titleTemplate={`%s | Brokalia`}
      meta={
        yoastHead
          ? []
          : [
            {
              name: `description`,
              content: metaDescription,
            },
            {
              property: `og:title`,
              content: title,
            },
            {
              property: `og:description`,
              content: metaDescription,
            },
            {
              property: `og:type`,
              content: `website`,
            },
            {
              name: `twitter:card`,
              content: `summary`,
            },
            {
              name: `twitter:creator`,
              content: site.siteMetadata.author,
            },
            {
              name: `twitter:title`,
              content: title,
            },
            {
              name: `twitter:image`,
              content: image,
            },
            {
              name: `twitter:description`,
              content: metaDescription,
            },
            {
              name: `keywords`,
              content: site.siteMetadata.keywords,
            },
            {
              name: `robots`,
              content: `index,follow`,
            },
            {
              name: `author`,
              content: site.siteMetadata.author,
            },
            {
              name: `url`,
              content: site.siteMetadata.siteUrl,
            },
          ].concat(meta)
      }
    >
      {yoastHead && parse(yoastHead)}
    </Helmet>
  )
}

Seo.propTypes = {
  description: PropTypes.string,
  keywords: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo

// return (
//     <Helmet
//       htmlAttributes={{
//         lang,
//       }}
//       title={title}
//       //titleTemplate={`%s | ${site.siteMetadata.title}`}
//       titleTemplate={`%s | Brokalia`}
//       meta={[
//         {
//           name: `description`,
//           content: metaDescription,
//         },
//         {
//           property: `og:title`,
//           content: title,
//         },
//         {
//           property: `og:description`,
//           content: metaDescription,
//         },
//         {
//           property: `og:type`,
//           content: `website`,
//         },
//         {
//           name: `twitter:card`,
//           content: `summary`,
//         },
//         {
//           name: `twitter:creator`,
//           content: site.siteMetadata.author,
//         },
//         {
//           name: `twitter:title`,
//           content: title,
//         },
//         {
//           name: `twitter:description`,
//           content: metaDescription,
//         },
//         {
//           name: `keywords`,
//           content: site.siteMetadata.keywords,
//         },
//         {
//           name: `robots`,
//           content: `index,follow`,
//         },
//         {
//           name: `author`,
//           content: site.siteMetadata.author,
//         },
//         {
//           name: `url`,
//           content: site.siteMetadata.siteUrl,
//         },
//       ].concat(meta)}
//     />
//   )
